<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-radio
                    [derrors]="derrors"
                    formControlName="realEstateManaged"
                    direction="column"
                    columns="3"
                    [toggle]="true"
                    [isDefault]="false"
                    label="Location géré / non géré"
                  >
                  </pr-input-radio>
                </div>
              </div>
              @if (form?.get('realEstateManaged')?.value) {
                <div class="row">
                  <div class="col col-md-12">
                    <pr-input-column label="Gestionnaire" [derrors]="derrors">
                      <input formControlName="realEstateManager" type="text" />
                    </pr-input-column>
                  </div>
                </div>
              }
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-radio
                    [derrors]="derrors"
                    formControlName="realestateCategory"
                    direction="column"
                    [isDefault]="false"
                    columns="4"
                    [options]="realestateCategoryOptions"
                    label="Secteur"
                  >
                  </pr-input-radio>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
